import { ProductAnalyticsEvents } from "enum/ProductAnalyticsEvents";
import i18n from "i18n";
import { useMemo } from "react";
import { useStores } from "stores/setup/use-store";
import { formatTimelineForecastMarker } from "util/formatTimelineMarker/formatTimelineForecastMarker";

export function useForecastTimelineData() {
  const {
    dataStores: { forecastMapStore, userConfigStore },
  } = useStores();

  const allFrameTimes = useMemo(() => {
    if (!forecastMapStore.timelineData) return [];
    return forecastMapStore.timelineData?.allFrames
      ?.map((item) => {
        return {
          time: item.time,
        };
      })
      .sort((a, b) => a.time - b.time);
  }, [forecastMapStore.timelineData]);

  if (!forecastMapStore.timelineData) return null;

  const productAnalyticsEvent = () => {
    forecastMapStore.addProductAnalyticsEvent(
      ProductAnalyticsEvents.ForecastLayerMapStart,
      {
        environmental_variable: forecastMapStore.selectedEnvironmentalVariable,
      }
    );
  };

  return {
    currentIndex: forecastMapStore.currentIndex,
    isPlaying: forecastMapStore.isPlaying,
    elapsedTime: forecastMapStore.elapsedTime,
    pastLength: forecastMapStore.totalFrames,
    totalFrames: forecastMapStore.timelineData.totalFrames,
    allFrames: forecastMapStore.timelineData.allFrames,
    timeMarkers: formatTimelineForecastMarker(
      allFrameTimes,
      userConfigStore.timezone,
      i18n.language
    ),
    isVisible: forecastMapStore.show,
    onTogglePlayPause: () =>
      forecastMapStore.isPlaying
        ? forecastMapStore.stop()
        : forecastMapStore.play(),
    onChangeIndex: (index: number) => forecastMapStore.setCurrentIndex(index),
    productAnalyticsEvent: () => productAnalyticsEvent(),
  };
}
